import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ChooseRoute from "../components/choose_route/ChooseRoute";
import { bindActionCreators } from "redux";
import {
    getLineIsFetching,
    getRouteList,
    getAddingService,
} from "../../../data/booking/selectors/booking";
import {
    fetchLineList,
    addServiceData,
    cancelAddService,
} from "../../../data/booking/actions/booking";

class ChooseLineContainer extends Component {
    static propTypes = {
        addingService: PropTypes.object,
        fetchLineList: PropTypes.func,
        addServiceData: PropTypes.func,
        cancelAddService: PropTypes.func,
    };

    componentDidMount() {
        this.props.fetchLineList();
    }

    handleSelectRoute(route) {
        this.props.addServiceData({
            route: {
                id: route.id,
                title: route.title,
                lines: route.lines,
                pictures: route.pictures,
            },
        });
    }

    handleClickBack(e) {
        e.preventDefault();
        this.props.cancelAddService();
    }

    render() {
        const { isFetching, lines, addingService } = this.props;

        return (
            <ChooseRoute
                isLoading={isFetching}
                routes={lines}
                serviceType={addingService.serviceType}
                onSelectRoute={::this.handleSelectRoute}
                onClickBack={::this.handleClickBack}
            />
        );
    }
}

export default connect(
    (state) => ({
        addingService: getAddingService(state.booking),
        lines: getRouteList(state.booking),
        isFetching: getLineIsFetching(state.booking),
    }),
    (dispatch) =>
        bindActionCreators({ fetchLineList, addServiceData, cancelAddService }, dispatch)
)(ChooseLineContainer);
